function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import SignupButtonFieldsConfig from "segments/desktop/core-components/button/signup-button/fields-config";
import YoutubePopupButtonFieldsConfig from "segments/desktop/core-components/button/youtube-popup-button/fields-config";
export default {
    signupButtonConfig: {
        type: FIELD_TYPES.NESTED,
        label: "Signup Button",
        fields: _object_spread({}, SignupButtonFieldsConfig)
    },
    youtubePopupButtonConfig: {
        type: FIELD_TYPES.NESTED,
        label: "Youtube Button",
        fields: _object_spread({}, YoutubePopupButtonFieldsConfig)
    }
};
